function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IagrofyLogoFull = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "596",
    height: "131",
    viewBox: "0 0 596 131",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M115.557 0H0V115.775H115.557V0Z",
    fill: "#73B800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 11.0425H10.8496V18.7247H104.706V11.0425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 28.2402H10.8496V35.9224H104.706V28.2402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 62.645H10.8496V70.3235H104.706V62.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5831 79.8481H10.8496V87.5285H49.5831V79.8481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 79.8481H65.9727V87.5285H104.706V79.8481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5831 45.4473H10.8496V53.1239H49.5831V45.4473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 45.4473H65.9727V53.1239H104.706V45.4473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5831 97.0537H10.8496V104.734H49.5831V97.0537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 97.0537H65.9727V104.734H104.706V97.0537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.767 5.31348H210.074L245.852 98.9797H226.535L219.459 80.2395H177.431L170.219 98.9797H150.898L187.767 5.31348ZM182.32 65.9199H214.7L198.915 24.4573L182.32 65.9199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.978 24.9297C435.282 24.9297 451.335 41.1786 451.335 63.0864C451.335 84.7049 435.282 100.817 412.978 100.817C390.934 100.817 374.889 84.7049 374.889 63.0864C374.889 41.1786 390.934 24.9297 412.978 24.9297ZM412.978 83.1976C424.952 83.1976 432.967 74.3766 432.967 63.0864C432.967 51.505 424.952 42.5551 412.978 42.5551C401.269 42.5551 393.241 51.505 393.241 63.0864C393.241 74.3766 401.269 83.1976 412.978 83.1976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.74 16.9928C499.234 16.9928 503.852 18.9276 506.721 20.8477V2.46493C502.844 1.14925 497.828 0.0546875 492.569 0.0546875C475.43 0.0546875 468.078 11.7632 468.078 25.6719V30.6361H455.013V45.643H468.078V99.2287H487.124V45.643H508.485V30.6361H487.124V25.8101C487.126 20.3022 489.302 16.9928 494.74 16.9928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.617 25.9805C359.529 25.9805 357.652 26.2016 355.949 26.6089C355.949 26.6089 355.912 26.6126 355.896 26.6181C355.896 26.6181 355.885 26.6181 355.877 26.6218C355.232 26.7692 348.676 28.3484 344.716 31.7721V26.7618H325.53V99.2277H344.716V69.494C344.727 69.5013 344.745 69.505 344.753 69.5198V60.6619C344.753 49.8932 349.341 43.7515 358.638 43.7515C364.744 43.7515 369.902 45.6771 371.431 47.1642V27.9559C369.089 26.8853 365.634 25.9805 361.617 25.9805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.69 30.5518L557.532 77.4153L536.319 30.5518H515.312L548.405 99.255L546.087 105.111C543.369 111.369 540.53 114.487 534.294 114.441C525.984 114.38 524.106 111.71 521.961 109.641V128.106C525.409 129.639 529.767 130.852 534.294 130.852C550.156 130.852 559.25 122.574 566.3 104.356L595.912 30.5537H574.69V30.5518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.097 26.9205V34.33C294.354 29.62 287.3 26.7583 277.808 26.7583C258.014 26.7583 244.59 42.893 244.59 62.7426C244.59 82.3028 258.014 98.4412 277.808 98.4412C286.896 98.4412 294.083 95.4357 299.097 90.8695V97.588C299.097 110.004 290.934 114.377 282.019 114.377C271.493 114.377 265.737 112.689 260.925 109.767V127.333C265.993 129.607 271.921 131 281.739 131C303.167 131 318.082 118.425 318.082 93.4401V26.9187H299.097V26.9205ZM299.097 74.1691C295.441 78.0167 289.472 81.0184 283.099 81.0184C271.434 81.0184 263.977 73.4486 263.977 62.7444C263.977 51.8891 271.302 44.1866 283.099 44.1866C289.611 44.1866 295.839 47.6103 299.097 51.1852V74.1691Z",
    fill: "black"
  }));
});